export default __webpack_public_path__ + "static/maksym-vinnik-fc8ccff828398444bbf4419d208884be.png";